import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sendForm } from '@emailjs/browser';
import Banner from '../../components/Banner/banner';
import SEO from '../../components/SEO/SEO';
import imgBanner from '../../assets/img/slider-pagina-writer.jpg';
import ticketCard from '../../assets/logo/ticket-card.png';
import './contact.scss';

const Contact = () => {
  const [t] = useTranslation('global');
  const [status, setStatus] = useState('idle'); // 'idle' | 'sending' | 'success' | 'error'

  const sendEmail = (e) => {
    e.preventDefault();
    const formElement = e.target;
    setStatus('sending');

    sendForm(
      'service_tw28tvg',
      'template_jfzp9mq',
      formElement,
      'op-bEmNqbabpo_lB0'
    )
      .then(() => {
        setStatus('success');
        formElement.reset();
      })
      .catch((error) => {
        console.error('EmailJS Error:', error);
        setStatus('error');
      });
  };

  return (
    <main className="globalContainer">
      <SEO title={t('ContactTitle')} canonicalPath="/contact" />

      <Banner name={imgBanner} alt="Contact Laura Candela" />

      <section className="globalSection" aria-label="Contact Section">
        <h1 className="sectionTitle">{t('ContactTitle')}</h1>

        <div className="contactLayoutWrapper">
          {/* Business Card Showcase */}
          <div className="businessCardShowcase">
            <div className="cardFrame">
              <img
                src={ticketCard}
                alt="Laura Candela - Actriz · Locutora"
                className="businessCardImg"
                loading="eager"
              />
            </div>
            <div className="cardDirectDetails">
              <p className="cardDetailItem">
                <span className="detailLabel">Direct:</span>
                <a href="mailto:laura@lauracandela.com" className="detailLink">
                  laura@lauracandela.com
                </a>
              </p>
              <p className="cardDetailItem">
                <span className="detailLabel">General:</span>
                <a href="mailto:info@lauracandela.com" className="detailLink">
                  info@lauracandela.com
                </a>
              </p>
              <p className="cardDetailItem">
                <span className="detailLabel">US Tel:</span>
                <a href="tel:+12028689638" className="detailLink">
                  +1 (202) 868-9638
                </a>
              </p>
              <p className="cardDetailItem">
                <span className="detailLabel">WhatsApp:</span>
                <a
                  href="https://wa.me/34646802707"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="detailLink"
                >
                  +34 646 80 27 07
                </a>
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <form
            method="post"
            id="contact-form"
            className="formBox ticketFormBox"
            onSubmit={sendEmail}
            noValidate={false}
          >
            <div className="formGroup">
              <label htmlFor="from_name">{t('ContactForm.Name')}</label>
              <input
                id="from_name"
                className="contactInput"
                type="text"
                name="from_name"
                placeholder={t('ContactForm.Name')}
                required
                autoComplete="name"
              />
            </div>

            <div className="formGroup">
              <label htmlFor="subject">{t('ContactForm.Subject')}</label>
              <input
                id="subject"
                className="contactInput"
                type="text"
                name="subject"
                placeholder={t('ContactForm.Subject')}
                required
              />
            </div>

            <div className="formGroup">
              <label htmlFor="from_email">{t('ContactForm.Email')}</label>
              <input
                id="from_email"
                className="contactInput"
                type="email"
                name="from_email"
                placeholder="ejemplo@correo.com"
                required
                autoComplete="email"
              />
            </div>

            <div className="formGroup">
              <label htmlFor="message">{t('ContactForm.Message')}</label>
              <textarea
                id="message"
                className="contactInput"
                name="message"
                placeholder={t('ContactForm.Message')}
                required
                rows={4}
              />
            </div>

            {status === 'success' && (
              <div className="statusAlert success" role="alert">
                {t('ContactForm.Success')}
              </div>
            )}

            {status === 'error' && (
              <div className="statusAlert error" role="alert">
                {t('ContactForm.Error')}
              </div>
            )}

            <button
              id="submit"
              type="submit"
              className="submitButton ticketSubmitButton"
              disabled={status === 'sending'}
            >
              {status === 'sending'
                ? t('ContactForm.Sending')
                : t('ContactForm.Send')}
            </button>
          </form>
        </div>

        {/* Global Representation Network */}
        <div className="representationSection">
          <h2 className="representationTitle">REPRESENTATION</h2>
          <div className="representationGrid">
            <div className="repCard">
              <h3 className="repRole">GLOBAL MANAGEMENT</h3>
              <p className="repAgency">ROLU Entertainment</p>
              <p className="repContacts">Ann Bradstreet Brown / Luis Sanchez-Canete</p>
              <p className="repContactLine">
                <a href="mailto:ann@roluentertainment.com" className="repLink">ann@roluentertainment.com</a>
              </p>
              <p className="repContactLine">
                <a href="mailto:luis@roluentertainment.com" className="repLink">luis@roluentertainment.com</a>
              </p>
              <p className="repContactLine">
                <a href="tel:+18185683646" className="repLink">+1 (818) 568-3646</a>
              </p>
            </div>

            <div className="repCard">
              <h3 className="repRole">US COMMERCIAL</h3>
              <p className="repAgency">Aqua Talent Agency</p>
              <p className="repContacts">Lawrence Har / Alex Clare</p>
              <p className="repContactLine">
                <a href="mailto:assistant@aquatalent.com" className="repLink">assistant@aquatalent.com</a>
              </p>
              <p className="repContactLine">
                <a href="mailto:lhar@aquatalent.com" className="repLink">lhar@aquatalent.com</a>
              </p>
              <p className="repContactLine">
                <a href="tel:+13108598889" className="repLink">+1 (310) 859-8889</a>
              </p>
            </div>

            <div className="repCard">
              <h3 className="repRole">US VOICEOVER</h3>
              <p className="repAgency">Atlas Talent Agency</p>
              <p className="repContacts">Voiceover Division</p>
              <p className="repMeta">New York & Los Angeles</p>
            </div>

            <div className="repCard">
              <h3 className="repRole">SPAIN THEATRICAL</h3>
              <p className="repAgency">
                <a
                  href="https://brossontalent.com/D/product/laura-candela/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="repLink"
                >
                  Brosson Talent
                </a>
              </p>
              <p className="repContacts">Amparo Martín Catalá</p>
              <p className="repContactLine">
                <a href="mailto:amparo@brossontalent.com" className="repLink">amparo@brossontalent.com</a>
              </p>
              <p className="repContactLine">
                <a href="tel:+34619113601" className="repLink">+34 619 11 36 01</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;